import { makeStyles } from "@mui/styles";

export const EventScheduleStyle = makeStyles((theme) => ({
  inviteAdminModel: {
    "&.MuiModal-root": {
      "& .MuiPaper-root": {
        maxWidth: "458px",
      },
    },
  },
  uploadBtn: {
    [theme.breakpoints.down("lg")]: {
      "&.MuiButtonBase-root": {
        padding: "8px 24px",
        minWidth: "unset",
        "& .content": {
          fontSize: 16,
        },
      },
    },
  },
  leavingModel: {
    "&.MuiModal-root": {
      "& .MuiPaper-root": {
        maxWidth: 458,
        width: "fit-content",
        padding: 0,
      },
    },
  },
  modalHead: {
    "&.MuiStack-root": {
      padding: "20px 26px",
      borderBottom: "1px solid #EAEDF0",
      "& h4": {
        fontWeight: 700,
        fontSize: 24,
        padding: 0,
        lineHeight: "31px",
        color: "var(--blackGray)",
        maxWidth: "95%",
        textAlign: "left",
        [theme.breakpoints.down("md")]: {
          marginBottom: 12,
          fontSize: 22,
          lineHeight: "25px",
        },
        [theme.breakpoints.down("sm")]: {
          fontSize: 18,
        },
      },
      "& .MuiIconButton-root": {
        backgroundColor: "var(--primaryLighter)",
        height: 25,
        width: 25,
        "& svg": {
          margin: 0,
          marginBottom: 0,
          color: "var(--primary)",
        },
        "&:hover": {
          backgroundColor: "var(--primaryGradientLighter)",
        },
      },
    },
  },
  container: {
    position: "static",
    textAlign: "center",
    "& .MuiDialogActions-root": {
      justifyContent: "center",
      backgroundColor: "#F6F6FD",
      padding: "24px 40px 18px",
      borderRadius: 5,
      [theme.breakpoints.down("sm")]: {
        padding: "18px 20px",
      },
    },
    "& .MuiDialogContent-root": {
      padding: "0 60px",
      marginBottom: 20,
      [theme.breakpoints.down("sm")]: {
        padding: "0 16px",
      },
      "& .info": {
        marginBottom: 10,
        marginTop: 24,
        [theme.breakpoints.down("md")]: {
          marginBottom: 12,
          width: 250,
        },
      },
    },

    "& p": {
      fontSize: 14,
      lineHeight: "21px",
      color: "var(--gray)",
      "& span": {
        fontWeight: 700,
        marginRight: 4,
      },
    },
  },
  cancelButton: {
    "&.MuiButtonBase-root": {
      background: "transparent",
      color: "var(--primary)",
    },
  },
  attentionButton: {
    "& .MuiButtonBase-root": {
      padding: [[8, 37]],
      borderRadius: 10,
      width: "auto",
      "& .content": {
        fontSize: 16,
      },
      [theme.breakpoints.down("md")]: {
        padding: [[8, 28]],
      },
    },
  },
  logoutButton: {
    "&.MuiButtonBase-root": {
      color: "var(--white)",
    },
  },
  title: {
    "&.MuiTypography-root": {
      fontWeight: 700,
      lineHeight: "31.25px",
      fontSize: "24px",
      whiteSpace: "nowrap",
      //   marginRight: 32,
      textOverflow: "ellipsis",
      overflow: "hidden",
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
        lineHeight: "26px",
        whiteSpace: "unset",
        "-webkit-line-clamp": "2",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        padding: 0,
        margin: "20px 32px 20px 0",
      },
    },
  },
  modalHeader: {
    position: "sticky",
    top: 0,
    background: "var(--white)",
    zIndex: 3,
  },
  innerTabsWrapper: {
    width: "100%",
    background: "var(--white)",
    borderRadius: 8,
    position: "relative",
    boxShadow: "0px 9px 20px 0px #968FB01A",
    zIndex: 2,
    overflowX: "auto",
    [theme.breakpoints.down("sm")]: {
      //   margin: "30px -16px 10px -16px",
      paddingBottom: 10,
      width: "unset",
      borderRadius: 0,
    },
  },
  listitemTab: {
    "&.MuiListItem-root": {
      color: "var(--gray)",
      opacity: 1,
      minWidth: 0,
      display: "flex",
      alignItems: "center",
      width: "fit-content",
      padding: [[21, 12]],
      margin: [[0, 15]],
      position: "relative",
      cursor: "pointer",
      flexDirection: "row",
      flex: "0 0 auto",
      [theme.breakpoints.down("md")]: {
        margin: "0 12px",
      },
      [theme.breakpoints.down("767")]: {
        margin: 0,
        padding: 16,
      },
      [theme.breakpoints.down("sm")]: {
        background: "var(--white)",
      },
      "& span": {
        display: "inline-block",
        marginLeft: 8,
      },
      "&::after": {
        position: "absolute",
        content: '""',
        height: 4,
        width: "100%",
        background: "var(--Tertiary)",
        borderRadius: "4px 4px 0px 0px",
        left: 0,
        opacity: 0,
        bottom: 0,
        transition: "all 0.3s ease-in-out",
        zIndex: 1,
        [theme.breakpoints.down("sm")]: {
          zIndex: 1,
        },
      },
      "&.active, &:hover": {
        color: "var(--Tertiary)",
        "&::after": {
          opacity: 1,
        },
      },
      "& svg": {
        flex: "0 0 auto",
      },
    },
  },
  heading: {
    "& .MuiTypography-h5": {
      fontSize: 30,
      fontWeight: 700,
      lineHeight: "1",
      marginBottom: 4,
      color: "#2D2F39",
    },
  },
  detailHeading: {
    "&.MuiTypography-root": {
      color: "rgba(134, 101, 10, 1)",
      fontSize: 14,
      fontWeight: 700,
      marginBottom: 24,
      [theme.breakpoints.down("md")]: {
        marginBottom: 20,
      },
    },
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "20px 25px",
    gap: 10,
    marginLeft: "-25px",
    marginRight: "-25px",
    bottom: 0,
    zIndex: 99,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      padding: "15px",
      gap: 10,
      marginLeft: "-15px",
      marginRight: "-15px",
    },
    "& .MuiButtonBase-root": {
      margin: 0,
      padding: "9.5px 25px",
      lineHeight: "21px",
      width: "auto",
      minWidth: "170px",
      borderRadius: 10,
      "& span": {
        fontSize: 16,
        fontWeight: 700,
      },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
  },
  createLinkButton: {
    "&.MuiButtonBase-root": {
      padding: "10.5px 25px",
      color: "var(--white)",
    },
  },
  shape: {
    position: "absolute",
    zIndex: -2,
  },
  shape1: {
    top: "20%",
    right: "10%",
  },
  shape2: {
    bottom: "5%",
    left: "0%",
  },
  formGrid: {
    "& .react-tel-input": {
      "& .form-control": {
        fontSize: 18,
        fontWeight: 700,
        color: "#202024",
      },
    },
    "& .MuiFormControl-root.MuiTextField-root": {
      width: "100%",
    },
  },
  downloadCsvButton: {
    "&.MuiTypography-root": {
      padding: "12px 0 0 0",
      fontSize: "14px",
      fontWeight: 500,
      color: "var(--primary)",
      "&:hover": {
        color: "var(--TertiaryDarker)",
        cursor: "pointer",
        textDecoration: "underline",
      },
    },
  },
  uploadOut: {
    height: 40,
    width: "100%",
    borderRadius: 10,
    background: "#F6F6FD80",
    cursor: "pointer",
    position: "relative",
    flex: "0 0 auto",
    overflow: "hidden",
    "& .MuiBox-root": {
      minHeight: "0",
    },
  },
  uploadText: {
    "&.MuiTypography-root": {
      fontSize: 14,
      lineHeight: "28px",
      color: "var(--gray)",
    },
  },
  inputUpload: {
    "&.MuiFormControl-root": {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0,
      top: "-40px",
      "& .MuiInputBase-root": {
        height: "100%",
        "& .MuiInputBase-input": {
          padding: 0,
          height: "100%",
          cursor: "pointer",
        },
      },
    },
  },
  uploadWrapper: {
    borderRadius: 8,
    padding: "10px 8px",
    border: "1px solid #CBCBCF",
    backgroundColor: "#F5F5F5",
    position: "relative",
    cursor: "pointer",
    "& .MuiTypography-h6": {
      color: "var(--gray)",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "18px",
      "& span": {
        color: theme.palette.blue.main,
        marginLeft: 4,
      },
    },
    "& input": {
      cursor: "pointer",
    },
    "& $inputUpload": {
      top: 0,
      zIndex: 2,
    },
  },
  btnWrap: {
    "& .MuiButtonBase-root": {
      height: "fit-content",
      minWidth: 150,
      padding: "11px 19px",
      "&.MuiButton-contained": {
        padding: "12px 19px",
        background:
          "linear-gradient(132.61deg, #E87637 32.09%, rgba(232, 118, 55, 0.5) 163.78%)",
        border: 0,
      },
      "&.MuiButton-outlined": {
        backgroundColor: "#F2E7F5",
      },
      "& .content": {
        fontSize: 16,
        fontWeight: 700,
        lineHeight: "1",
      },
    },
  },
  downloadEventRosterBtn: {
    "&.MuiButtonBase-root": {
      borderRadius: "8px",
      border: "1px solid var(--primary)",
      "&.MuiIconButton-root": {
        fontSize: "14px",
        gap: "10px",
        color: "var(--primary)",
        fontWeight: 700,
      },
    },
  },
  statisticBox: {
    boxShadow: `0px 0px 14px 0px #0000001A`,
    padding: 24,
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    height: "calc(100% - 30px)",
    marginTop: 30,
    position: "relative",
    "& h5": {
      color: "#747787",
      fontWeight: 700,
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
      },
    },
    "& h4": {
      color: "#2D2F39",
      fontSize: 32,
      fontWeight: 700,
      [theme.breakpoints.down("sm")]: {
        fontSize: 26,
      },
    },
    "& p": {
      color: "#898994",
      fontSize: 18,
      [theme.breakpoints.down("sm")]: {
        fontSize: 16,
      },
    },
  },
  rosterShape: {
    position: "absolute",
    right: "25%",
    top: "14%",
  },
  stepsShape: {
    position: "absolute",
    left: "40%",
    bottom: 0,
    "& img": {
      display: "block",
    },
  },
  progressShape: {
    position: "absolute",
    right: 0,
    bottom: "30%",
    "& img": {
      display: "block",
    },
  },
  beginShape: {
    position: "absolute",
    top: -12,
    right: "30%",
    transform: "rotate(-90deg)",
    "& img": {
      display: "block",
    },
  },
  frequencySelect: {
    textAlign: "right",
    "& .MuiInputBase-root": {
      borderRadius: 8,
      backgroundColor: "#FFFFFF",
      minWidth: 100,
      "& .MuiInputBase-input": {
        paddingLeft: 10,
        fontWeight: 500,
        fontSize: 14,
        color: "#747787",
        textAlign: "start",
      },
      "& svg": {
        position: "absolute",
        right: 12,
        top: "50%",
        transform: "translateY(-50%)",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#EAEDF0",
      },
    },
  },
  assessmentBox: {
    boxShadow: `0px 0px 14px 0px #0000001A`,
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: "24px 0",
    height: "100%",
  },
  assessmentTitle: {
    position: "relative",
    paddingLeft: 24,
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 5,
      width: 4,
      height: 25,
      backgroundColor: "#8B3F9E",
      borderRadius: "0 4px 4px 0",
    },
    "& h6": {
      fontWeight: 700,
      fontSize: 24,
      lineHeight: "normal",
      [theme.breakpoints.down("md")]: {
        fontSize: 20,
      },
    },
    "& p": {
      color: "#747787",
    },
  },
  assessmentSelect: {
    [theme.breakpoints.down("sm")]: {
      marginTop: 10,
      width: "100%",
    },
    "& .MuiFormControl-root": {
      maxWidth: 100,
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        width: "100%",
      },
    },
    "& .MuiInputBase-root": {
      borderRadius: 4,
      backgroundColor: "#FFFFFF",
      minWidth: 100,
      "& .MuiInputBase-input": {
        paddingLeft: 10,
        fontWeight: 500,
        fontSize: 14,
        color: "#747787",
      },
      "& svg": {
        position: "absolute",
        right: 12,
        top: "50%",
        transform: "translateY(-50%)",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#EAEDF0",
      },
    },
  },
  timelineWrapper: {
    boxShadow: `0px 0px 14px 0px #0000001A`,
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: "24px",
    marginBottom: 30,
  },
  timelineBox: {
    flex: 1,
    position: "relative",
    display: "flex",
    justifyContent: "flex-end",
    minWidth: 200,
    marginLeft: 20,
    "&:first-child": {
      flex: "none",
      maxWidth: 200,
      width: "100%",
      marginLeft: 0,
    },
  },
  stepLine: {
    position: "absolute",
    top: "50%",
    right: 20,
    width: "100%",
    height: 2,
    zIndex: 1,
    backgroundColor: "#CBCBCF",
    "&.completed": {
      backgroundColor: "#29904C",
    },
    "&.active": {
      backgroundColor: "#9944B5",
    },
  },
  timelineContent: {
    maxWidth: 200,
    width: "100%",
    borderRadius: 4,
    backgroundColor: "#FBFBFB",
    border: "1px solid #CBCBCF",
    padding: 16,
    color: "#898994",
    position: "relative",
    zIndex: 2,
    "& .MuiChip-root": {
      backgroundColor: "#CBCBCF",
      textTransform: "capitalize",
      padding: "0",
      fontSize: 12,
      height: 20,
    },
    "&.completed": {
      backgroundColor: "#F2FBF5",
      borderColor: "#29904C",
      color: "#29904C",
      "& .MuiChip-root": {
        backgroundColor: "#C3EFD1",
        color: "#29904C",
      },
    },
    "&.active": {
      backgroundColor: "#FBF6FD",
      borderColor: "#9944B5",
      color: "#9944B5",
      "& .MuiChip-root": {
        backgroundColor: "#ECD8F6",
        color: "#9944B5",
      },
    },
  },
  notDataFound: {
    backgroundColor: "#fff",
    minHeight: 500,
    display: "flex",
    alignItems: "center",
    borderRadius: 10,
    justifyContent: "center",
    "& p": {
      maxWidth: 380,
      margin: "0 auto",
      textAlign: "center",
      fontSize: 32,
      color: "#898994",
    },
  },
  emailPreviewModal: {
    "&.MuiModal-root": {
      "& .MuiPaper-root": {
        maxWidth: "700px",
      },
    },
  },
}));
